const initMysteryModals = (root = document) => {
  const modals = root.querySelectorAll('[data-mystery-box-modal]');
  const rootEl = document.documentElement;

  modals.forEach((modal) => {
    if (modal.dataset.mysteryInit === 'true') return;
    modal.dataset.mysteryInit = 'true';

    const container =
      modal.closest('[data-section-id]') ||
      modal.closest('section') ||
      modal.parentElement;

    if (!container) return;

    const dialog = modal.querySelector('.mystery-modal__dialog');
    const closeButtons = modal.querySelectorAll('[data-mystery-box-close]');
    const openers = container.querySelectorAll('[data-mystery-box-open]');

    let scrollY = 0;

    const lockScroll = () => {
      scrollY = window.scrollY || window.pageYOffset || 0;

      rootEl.classList.add('has-mystery-modal-open');

      rootEl.style.position = 'fixed';
      rootEl.style.top = `-${scrollY}px`;
      rootEl.style.left = '0';
      rootEl.style.right = '0';
      rootEl.style.width = '100%';
      rootEl.style.overflow = 'hidden';
    };

    const unlockScroll = () => {
      rootEl.classList.remove('has-mystery-modal-open');

      rootEl.style.position = '';
      rootEl.style.top = '';
      rootEl.style.left = '';
      rootEl.style.right = '';
      rootEl.style.width = '';
      rootEl.style.overflow = '';

      window.scrollTo(0, scrollY);
    };

    const openModal = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
    };

    openers.forEach((btn) => {
      if (btn.dataset.mysteryBound === 'true') return;
      btn.dataset.mysteryBound = 'true';

      btn.addEventListener('click', (event) => {
        event.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    modal.addEventListener('click', (event) => {
      if (!dialog.contains(event.target)) closeModal();
    });

    if (!window.__mysteryKeydownBound) {
      window.__mysteryKeydownBound = true;

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const opened = document.querySelector('[data-mystery-box-modal].is-open');
        if (!opened) return;

        opened.classList.remove('is-open');
        opened.setAttribute('aria-hidden', 'true');

        if (rootEl.style.position === 'fixed') {
          const top = rootEl.style.top;
          const y = top ? Math.abs(parseInt(top, 10)) : 0;

          rootEl.classList.remove('has-mystery-modal-open');

          rootEl.style.position = '';
          rootEl.style.top = '';
          rootEl.style.left = '';
          rootEl.style.right = '';
          rootEl.style.width = '';
          rootEl.style.overflow = '';

          window.scrollTo(0, y);
        }
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initMysteryModals();
});

document.addEventListener('shopify:section:load', (event) => {
  initMysteryModals(event.target);
});